import DataLoad from "./DataLoad/DataLoad";
import { BaseNodeDataType } from "../WorkflowUtils";
import DataLoadRecon from "./DataLoad/DataLoadRecon";
import { UAction, UseCaseType } from "@supportinitiative/common";
import AnchorMatch from "./Match/AnchorMatch";
import DeriveData from "./DeriveData/DeriveData";
import StatusUpdate from "./StatusUpdate/StatusUpdate";
import Report from "./Report/Report";
import SummaryStats from "./SummaryStats/SummaryStats";
import Notification from "./Notification/Notification";
import BulkDataLoadRecon from "./DataLoad/BulkDataLoadRecon";

type ActionRouterProps = {
  from: "ORCHESTRATOR" | "RECONCILIATION" | "MONITORING" | "TRIGGER";
  node: BaseNodeDataType;
  actions: UAction[];
  recon?: UseCaseType["definition"]["recons"][number];
  cancel: () => void;
  save: (values: any) => void;
};

export default function ActionRouter(props: ActionRouterProps) {
  const { from, node, actions, save, cancel, recon } = props;

  const action = actions.find((a) => a.id === node.id);

  if (action) {
    if (from.toUpperCase() === "ORCHESTRATOR") {
      if (action.type.toUpperCase() === "RECONCILIATION") {
        return <></>; // This will be displayed separately as RECON
      } else if (action.type.toUpperCase() === "MONITORING") {
        return <></>; // This will be displayed separately as RECON
      } else if (action.type.toUpperCase() === "DATALOAD") {
        return <DataLoad save={save} cancel={cancel} action={action} />;
      }
    } else if (from.toUpperCase() === "RECONCILIATION") {
      if (action.type.toUpperCase() === "DATALOAD") {
        return (
          <DataLoadRecon
            save={save}
            cancel={cancel}
            action={action}
            recon={recon}
          />
        );
      } else if (action.type.toUpperCase() === "BULK_DATALOAD") {
        return (
          <BulkDataLoadRecon
            save={save}
            cancel={cancel}
            action={action}
            recon={recon}
          />
        );
      } else if (action.type.toUpperCase() === "ANCHOR_MATCH") {
        return (
          <AnchorMatch
            save={save}
            cancel={cancel}
            action={action}
            recon={recon as UseCaseType["definition"]["recons"][number]}
          />
        );
      } else if (action.type.toUpperCase() === "DERIVE_DATA") {
        return (
          <DeriveData
            save={save}
            cancel={cancel}
            action={action}
            recon={recon as UseCaseType["definition"]["recons"][number]}
          />
        );
      } else if (action.type.toUpperCase() === "STATUS_UPDATE") {
        return (
          <StatusUpdate
            save={save}
            cancel={cancel}
            action={action}
            recon={recon as UseCaseType["definition"]["recons"][number]}
          />
        );
      } else if (action.type.toUpperCase() === "REPORT") {
        return (
          <Report
            save={save}
            cancel={cancel}
            action={action}
            recon={recon as UseCaseType["definition"]["recons"][number]}
          />
        );
      } else if (action.type.toUpperCase() === "SUMMARY_STATS") {
        return (
          <SummaryStats
            save={save}
            cancel={cancel}
            action={action}
            recon={recon as UseCaseType["definition"]["recons"][number]}
          />
        );
      } else if (action.type.toUpperCase() === "NOTIFICATION") {
        return (
          <Notification
            save={save}
            cancel={cancel}
            action={action}
            recon={recon as UseCaseType["definition"]["recons"][number]}
          />
        );
      }
    }
  }

  return <></>;
}
